import React, { FC, useEffect, useState } from 'react';
import { Drawer } from '@one-thd/sui-atomic-components';
import { ListProvider } from '../../context/transactable-gift-cards-context';
import { IGiftCardCommonData } from '../../models/common-models';
import { useAuthActivity } from '../../hooks/use-auth-activity';
import { getCustomerInfo } from '../../utils/general';
import ScanToPayDrawerContainerBody from './scan-to-pay-drawer-container-body';
import { LoadingSpinner } from '../loading-spinner';

interface ScanToPayDrawerContainerProps {
  isOpen: boolean;
  onClose: () => void;
  singleCard?: IGiftCardCommonData | null;
}

export const ScanToPayDrawerContainer: FC<ScanToPayDrawerContainerProps> = (props) => {
  const { isOpen, onClose, singleCard } = props;
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const { jwt } = getCustomerInfo();

  const { matchedAuthEvent, isAccountActivityLoading, fetchUserAuthActivity, clearAuthEvent } = useAuthActivity();

  const shouldShowOTPContent = !matchedAuthEvent && !isOTPVerified;

  const handleOTPVerified = (verified: boolean) => {
    setIsOTPVerified(verified);
  };

  useEffect(() => {
    if (isAccountActivityLoading) {
      return;
    }
    if (!matchedAuthEvent && !isOTPVerified && jwt && isOpen) {
      fetchUserAuthActivity(jwt);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsOTPVerified(false);
    clearAuthEvent();
    onClose();
  };

  const renderContent = () => {
    const waitForLoading = Boolean(singleCard);

    if (isAccountActivityLoading && waitForLoading) {
      return <LoadingSpinner />;
    }

    return (
      <ListProvider>
        <ScanToPayDrawerContainerBody
          isOpen={isOpen}
          isAccountActivityLoading={isAccountActivityLoading}
          shouldShowOTPContent={shouldShowOTPContent}
          onOTPVerified={handleOTPVerified}
          onClose={handleClose}
          singleCard={singleCard}
        />
      </ListProvider>
    );
  };

  return (
    <Drawer fixed open={isOpen} onClose={handleClose}>
      {renderContent()}
    </Drawer>
  );
};
